module.exports = __webpack_public_path__ + "img/homepage-jumbo.1ef05ddd.jpg";